
import { Link } from 'react-router-dom';
import '../Footer/footer.css';
import { Container, Row , Col  , List , ListGroup , ListGroupItem } from 'reactstrap';


function  Footer ()  {

    let date = new Date();
    let year = date.getFullYear();

    const MY__ACCONTS = [
        {
            display: "Author Profile",
            url:'/seller-profile'
        },
        {
            display: "Create Item",
            url:'/create'
        },
        {
            display: "Edit Profile",
            url:'/edit-profile'
        },
        {
            display: "Author Profile",
            url:'/seller-profile'
        }
    ];


    const RESOURCES = [
        {
            display: "Help Center",
            url:'#'
        },
        {
            display: "Partner",
            url:'#'
        },
        {
            display: "Community",
            url:'#'
        },
        {
            display: "Activity",
            url:'#'
        }
    ];

    const COMPANY = [
        {
            display: "About",
            url:'#'
        },
        {
            display: "Career",
            url:'#'
        },
        {
            display: "Ranking",
            url:'#'
        },
        {
            display: "Contact Us",
            url:'/contact'
        }
    ];




    return(
        <footer  className="footer">
            <Container>
                <Row>
                    <Col lg="3" md='6' sm='6' className='mb-4'>
                        <div className='logo'>
                            <h2 className='d-flex gap-2  align-items-center'> 
                                <span> 
                                    <i className="ri-fire-fill"></i> 
                                </span> 
                                NFTs 
                            </h2>
                            <p>
                                welcome All to Nfts
                            </p>
                        </div>
                    </Col>

                    <Col lg="2" md='3' sm='6'  className='mb-4' >
                        <h5> My Accounts  </h5>
                        <ListGroup  className='List__group'>
                            {
                                MY__ACCONTS.map((item , index) => {
                                    return(
                                        <ListGroupItem  key={index}  className='list__item'>  
                                            <Link   to={item.url}>  {item.display}  </Link>
                                        </ListGroupItem>
                                    );
                                })
                            }
                        </ListGroup>
                    </Col>

                    <Col lg="2" md='3' sm='6' className='mb-4' >
                    <h5> Resources  </h5>
                        <ListGroup  className='List__group'>
                            {
                                RESOURCES.map((item , index) => {
                                    return(
                                        <ListGroupItem  key={index}  className='list__item'>  
                                            <Link   to={item.url}>  {item.display}  </Link>
                                        </ListGroupItem>
                                    );
                                })
                            }
                        </ListGroup>
                    </Col>

                    <Col lg="2" md='3' sm='6'   className='mb-4'>
                    <h5> COMPANY  </h5>
                        <ListGroup  className='List__group'>
                            {
                                COMPANY.map((item , index) => {
                                    return(
                                        <ListGroupItem  key={index}  className='list__item'>  
                                            <Link   to={item.url}>  {item.display}  </Link>
                                        </ListGroupItem>
                                    );
                                })
                            }
                        </ListGroup>
                    </Col>

                    <Col lg="3" md='6' sm='6'  className='mb-4'>
                        <h5> Newsletter  </h5>
                        <input  type='text'  placeholder='Email'  className='newsletters' />
                        <div className='social__linls  d-flex  gap-3  align-tems-center'>
                        <span> <Link  to="#"> <i class="ri-facebook-fill"></i> </Link> </span>
                            <span> <Link  to="#"> <i class="ri-instagram-line"></i>  </Link> </span>
                            <span> <Link  to="#"> <i class="ri-twitter-line"></i>  </Link> </span>
                            <span> <Link  to="#"> <i class="ri-telegram-fill"></i>  </Link> </span>
                            <span> <Link  to="#"> <i class="ri-discord-line"></i>  </Link> </span>
                        </div>
                    </Col>

                    <Col lg="12" className='mt-4  text-center'  >
                        <p  className='copyRights'>  
                            Copyrights {year} , Developed by Ahmed Saleh. All rights reserved  
                        </p>
                    </Col>


                    
                </Row>
            </Container>

            
        </footer>
    );
}

export  default  Footer;
